export enum SubmissionDetailsAppBarStatusType {
  Empty = "empty",
  MissingCompanyNameError = "missingCompanyNameError",
  GeneralError = "generalError",
  InProgress = "inProgress",
  Success = "success",
}
